import { get } from "../../service/api";

const GetMerchant = async (id) => {
    try {
        const response = await get(`/admin/merchant/${id}`);
        return response;
    } catch (error) {
        console.error('Error GetMerchant:', error);
        throw error;
    }
};

export default GetMerchant;